var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { attachProps } from "../../utils";
import MultiSelectFieldSync from "./impl/MultiSelectFieldSync";
import MultiSelectFieldAsync from "./impl/MultiSelectFieldAsync";
var MultiSelectField = function (props) {
    var _a = props.async, async = _a === void 0 ? false : _a, rest = __rest(props, ["async"]);
    var asyncRef = React.useRef(async);
    var asyncWarned = React.useRef(false);
    React.useEffect(function () {
        if (!asyncWarned.current && asyncRef.current !== async) {
            asyncWarned.current = true;
            console.error("A MultiSelectField has changed its async mode while mounted.  This is not supported and will result in bugs.");
        }
    }, [async]);
    if (async) {
        return React.createElement(MultiSelectFieldAsync, __assign({}, rest));
    }
    else {
        return React.createElement(MultiSelectFieldSync, __assign({}, rest));
    }
};
function ofItemType() {
    return MultiSelectField;
}
export default attachProps(MultiSelectField, {
    ofItemType: ofItemType
});
//# sourceMappingURL=MultiSelectField.js.map